// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type LotConfigurationStatusFragment = { __typename?: 'ProjectReadyPlanConfig', id: string, applied: boolean, canApply: { __typename?: 'PotentialOperation2', disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export const LotConfigurationStatusFragmentDoc = gql`
    fragment LotConfigurationStatus on ProjectReadyPlanConfig {
  id
  applied
  canApply {
    disabledReasons {
      message
    }
  }
}
    `;